import { isStorePanelHostname } from "./storePanelHostname";

export const isStorePanelLocation = (
  hostname: string = window.location.hostname,
  pathname: string = window.location.pathname,
): boolean =>
  isStorePanelHostname(hostname) ||
  /^\/(clinic|product|order)(\/|$)/i.test(pathname);
